import { RouteGuard } from '@/router/routeGuard';
import { RouteConfig } from 'vue-router';


const routes: Array<RouteConfig> = [
    {
      path: "/solicitacoes/acompanhamento-solicitacoes",
      name: "AcompanhamentoSolicitacoes",
      component: () => import("@/views/private/solicitacoes/AcompanhamentoSolicitacoes.vue"),
      beforeEnter: RouteGuard.acessoAdministrativo
    },
    {
      path: "/solicitacoes/detalhe-solicitacao",
      name: "DetalheSolicitacao",
      component: () => import("@/views/private/solicitacoes/DetalheSolicitacao.vue"),
      beforeEnter: RouteGuard.acessoAdministrativo
    },
    {
      path: "/solicitacoes/acompanhamento-novas-solicitacoes",
      name: "AcompanhamentoNovasSolicitacoes",
      component: () => import("@/views/private/solicitacoes/AcompanhamentoNovasSolicitacoes.vue"),
      beforeEnter: RouteGuard.acessoAdministrativo
    },
    {
      path: "/solicitacoes/detalhe-nova-solicitacao",
      name: "DetalheNovaSolicitacao",
      component: () => import("@/views/private/solicitacoes/DetalheNovaSolicitacao.vue"),
      beforeEnter: RouteGuard.acessoAdministrativo
    },
    {
      path: "/solicitacoes/sem-prestador",
      name: "SolicitacaoSemPrestador",
      component: () => import("@/views/private/solicitacoes/SolicitacaoSemPrestador.vue"),
      beforeEnter: RouteGuard.acessoAdministrativo
    }
]

export default routes;